import { render, staticRenderFns } from "./AdminBlanketVOBDetails.vue?vue&type=template&id=043b9cb0"
import script from "./AdminBlanketVOBDetails.vue?vue&type=script&lang=js"
export * from "./AdminBlanketVOBDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports